import React from 'react';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_eco-cloud-expert/artifacts/2spz5f2a_cexp.png" 
              alt="CloudExpert Logo" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-600 mb-4">
              Transformando empresas con tecnología de vanguardia
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Soluciones</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('solutions')} className="text-gray-600 hover:text-[#ff6b35] transition-colors">
                  Desarrollo de Software
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('solutions')} className="text-gray-600 hover:text-[#ff6b35] transition-colors">
                  Gestión de Nubes
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('solutions')} className="text-gray-600 hover:text-[#ff6b35] transition-colors">
                  Inteligencia Artificial
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Empresa</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('cases')} className="text-gray-600 hover:text-[#ff6b35] transition-colors">
                  Casos de Éxito
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('technologies')} className="text-gray-600 hover:text-[#ff6b35] transition-colors">
                  Tecnologías
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-600 hover:text-[#ff6b35] transition-colors">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-600">
                <Mail className="w-4 h-4 text-[#ff6b35]" />
                <span className="text-sm">contacto@cloudexpert.cl</span>
              </li>
              <li className="flex items-center gap-2 text-gray-600">
                <MapPin className="w-4 h-4 text-[#ff6b35]" />
                <span className="text-sm">Santiago, Chile</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} cloudexpert.cl. Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-600 hover:text-[#ff6b35] text-sm transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-600 hover:text-[#ff6b35] text-sm transition-colors">
                Términos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;